import request from './request';

export async function newMembers() {
    return await request('get', '/apiv2/new_members', {});
}

export async function followNewUser(id) {
    return await request('post', `/apiv2/followers/${id}/follow`);
}

export async function newMembersBlog(id) {
    return await request('get', `/apiv2/new_members_blog/${id}/new_members_blog`, {});
}

export async function newMembersProfile(id) {
    return await request('get', `/apiv2/new_members_profile/${id}/new_members_profile`, {});
}

export async function newMembersPetition(id) {
    return await request('get', `/apiv2/new_members_petition/${id}/new_members_petition`, {});
}

export async function newMembersCrowdpac(id) {
    return await request('get', `/apiv2/new_members_crowdpac/${id}/new_members_crowdpac`, {});
}

export async function newMembersNews(id) {
    return await request('get', `/apiv2/new_members_news/${id}/new_members_news`, {});
}